module.exports = __webpack_public_path__ + "img/dragon.45b5f881.svg";